/**
 * userpreferencesreducer.js
 * Created by calhosh on 8/28/2020.
 */
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {userTheme} from '../../util/uiconstants';

export default function userPreferencesReducer(state = initialState.userPreferences, action) {
	switch (action.type) {
		case types.GET_USER_PREFERENCES: {
			if (_.size(action.response) > 0) {
				let userPreferences = action.response;
				userPreferences.isPreferencesLoaded = true;
				return userPreferences;
			}
			return state;
		}

		case types.SET_USER_THEME:
		case types.SET_USER_PREFERENCES:
		case types.CREATE_USER_PREFERENCES: {
			let newTheme = userTheme.light;
			if (action.isDark) newTheme = userTheme.dark;
			else newTheme = userTheme.light;
			if (action.theme) newTheme = action.theme;
			const result = {...state, theme: newTheme};
			return result;
		}
		default:
			return state;
	}
}
